// Helpers compartidos para los ítems "tipo oración" (BaseSentence en el
// backend: competencias, unidades de competencia, RA, criterios...) que
// generan los builders de IA.
//
// La IA devuelve las 4 partes (action/content/condition/context); en el
// modal el ítem se muestra y edita como oración única (full_sentence), y al
// guardar se derivan "action" (primera palabra) y "verb" (si calza con la
// taxonomía), igual que el modo "Insertar" de CompetenceSentenceForm.vue.

// Compone el texto completo a partir de las 4 partes que retorna la IA.
export function composeSentence(parts) {
  return [parts.action, parts.content, parts.condition, parts.context]
    .filter((x) => x)
    .join(" ")
    .trim();
}

export function normalizeText(text) {
  return (text || "")
    .normalize("NFD")
    .replace(/([aeio])́|(u)[́̈]/gi, "$1$2")
    .normalize()
    .trim()
    .toLowerCase();
}

export function matchVerbId(word, verbs) {
  const normalized = normalizeText(word);
  if (!normalized) return null;
  const match = (verbs || []).find(
    (v) => normalizeText(v.name) === normalized
  );
  return match ? match.id : null;
}

// Deriva "action" (primera palabra) y "verb" (si calza con algún verbo de
// la taxonomía entregada) a partir del texto completo.
export function deriveActionVerb(full_sentence, verbs) {
  const action = (full_sentence || "").trim().split(/\s+/).shift() || "";
  return { action, verb: matchVerbId(action, verbs) };
}
